import buiss from '../../Images/buiss.svg'
import team from '../../Images/team.svg'
import tools from '../../Images/tools.svg'
import database from '../../Images/data.svg'

export const HomeObj =  {
 lightBg:false, 
 buttonlabel: 'Get Started',
 imgstart:false,
 lightTopLine :true,
 lightHeading:true,
 lightDesc:true,
 primary:true,
 start:false,
 img:buiss,
 alt:'Card',
 topline:'Marketing Agency',
 heading:'Lead Generation Specialist for Online Businesses',
 description:'We help business owners increase their revenue. Our team of unique specialist can help you achieve your business goals.'
}

export const HomeObj1 =  {
    lightBg:true, 
    buttonlabel: 'Learn More',
    imgstart:true,
    lightTopLine :false,
    lightHeading:false,
    lightDesc:false,
    primary:false,
    start:true,
     img:team,
     alt:'proj',
    topline:'Instant Setup',
    heading:'Extremely quick onboarding process',
    description:'Once you have joined, our team of specialist will reach out to you and get you set up in minutes.'
   }
   export const HomeObj2=  {
    lightBg:false, 
    buttonlabel: 'Subscribe Now',
    imgstart:'',
    lightTopLine :true,
    lightHeading:true,
    lightDesc:true,
    primary:true,
    start:'',
     img:tools,
     alt:'proj',
    topline:'Products',
    heading:'Get access to SEO marketing tools ',
    description:'We give acces to 31 tools that all enterpreneurs must be aware of as the lowest market price with a validity of one year.'
   }

   export const HomeObj3 =  {
    lightBg:true, 
    buttonlabel: 'Join Now',
    imgstart:'start',
    lightTopLine :false,
    lightHeading:false,
    lightDesc:false,
    primary:false,
    start:true,
     img:database,
     alt:'proj',
    topline:'Secure Database',
    heading:'All your data is stored on our secure server',
    description:'You will never have to worry about your information getting leaked. Our team of security experts will ensure your records are kept safe.Security of our clients is our primary goal.'
   }